import React from 'react';
import './partner-styles.css';

const PartnerApplicationList = ({
    applications,
    loading,
    pagination,
    onPageChange,
    onLimitChange,
    onViewDetails,
    partnerModel // 'CPL' or 'CPD' (default)
}) => {
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const formatCurrency = (amount) => {
        if (!amount) return '₹0';
        return `₹${amount.toLocaleString('en-IN')}`;
    };

    const getStatusBadgeClass = (status) => {
        const statusLower = status?.toLowerCase() || '';
        if (statusLower.includes('approved')) return 'partner-status-approved';
        if (statusLower.includes('rejected')) return 'partner-status-rejected';
        if (statusLower.includes('disbursed')) return 'partner-status-disbursed';
        return 'partner-status-pending';
    };

    return (
        <div className="partner-applications-table">
            {loading ? (
                <div className="partner-loading">
                    <i className="fa fa-spinner fa-spin fa-3x"></i>
                    <p style={{ marginTop: '20px' }}>Loading applications...</p>
                </div>
            ) : !applications || applications.length === 0 ? (
                <div className="partner-empty-state">
                    <div className="partner-empty-icon">
                        <i className="fa fa-folder-open"></i>
                    </div>
                    <div className="partner-empty-message">No Applications Found</div>
                </div>
            ) : (
                <>
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th style={{ minWidth: '180px', textAlign: 'center' }}>Created Date</th>
                                    <th style={{ minWidth: '150px', textAlign: 'center' }}>Application ID</th>
                                    <th style={{ minWidth: '150px', textAlign: 'center' }}>Mobile Number</th>

                                    {partnerModel === 'CPL' ? (
                                        <th style={{ minWidth: '150px', textAlign: 'center' }}>OTP Verified</th>
                                    ) : (
                                        <>
                                            <th style={{ minWidth: '150px', textAlign: 'center' }}>Current Status</th>
                                            <th style={{ minWidth: '150px', textAlign: 'center' }}>Disbursed Amount</th>
                                            <th style={{ minWidth: '150px', textAlign: 'center' }}>Disbursed Date</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {applications.map((app) => (
                                    <tr key={app.applicationId || app.id}>
                                        <td style={{ minWidth: '180px', textAlign: 'center' }}>{formatDate(app.createdAt)}</td>
                                        <td style={{ minWidth: '150px', textAlign: 'center' }}>
                                            <strong>{app.applicationId || app.id || 'N/A'}</strong>
                                        </td>
                                        <td style={{ minWidth: '150px', textAlign: 'center' }}>{app.mobile || 'N/A'}</td>

                                        {partnerModel === 'CPL' ? (
                                            <td style={{ minWidth: '150px', textAlign: 'center' }}>
                                                {app.otpVerified === true ? (
                                                    'Yes'
                                                ) : app.otpVerified === false ? (
                                                    'No'
                                                ) : (
                                                    'N/A'
                                                )}
                                            </td>
                                        ) : (
                                            <>
                                                <td style={{ minWidth: '150px', textAlign: 'center' }}>
                                                    {app.leadStatus || 'N/A'}
                                                </td>
                                                <td style={{ minWidth: '150px', textAlign: 'right' }}>{app.disbursalAmount ? formatCurrency(app.disbursalAmount) : '-'}</td>
                                                <td style={{ minWidth: '150px', textAlign: 'center' }}>{app.disbursalDate ? formatDate(app.disbursalDate) : '-'}</td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {pagination && (
                        <div className="partner-pagination">
                            <div className="partner-pagination-info">
                                Showing {pagination.from || 1} to {pagination.to || applications.length} of {pagination.total || applications.length} applications
                            </div>
                            <div className="partner-pagination-controls">
                                <select
                                    className="form-control input-sm"
                                    value={pagination.limit || 20}
                                    onChange={(e) => onLimitChange && onLimitChange(parseInt(e.target.value))}
                                    style={{ width: 'auto', display: 'inline-block', marginRight: '10px' }}
                                >
                                    <option value={10}>10 per page</option>
                                    <option value={20}>20 per page</option>
                                    <option value={50}>50 per page</option>
                                    <option value={100}>100 per page</option>
                                </select>

                                <button
                                    className="btn btn-default btn-sm"
                                    onClick={() => onPageChange && onPageChange(pagination.currentPage - 1)}
                                    disabled={pagination.currentPage <= 1}
                                >
                                    <i className="fa fa-chevron-left"></i> Previous
                                </button>

                                <span style={{ margin: '0 15px', fontSize: '14px' }}>
                                    Page {pagination.currentPage || 1} of {pagination.totalPages || 1}
                                </span>

                                <button
                                    className="btn btn-default btn-sm"
                                    onClick={() => onPageChange && onPageChange(pagination.currentPage + 1)}
                                    disabled={pagination.currentPage >= pagination.totalPages}
                                >
                                    Next <i className="fa fa-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default PartnerApplicationList;
